var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDesignCanvasHove(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 135,
    height: 112,
    viewBox: "0 0 135 112",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_28031",
    "data-name": "Group 28031",
    transform: "translate(-376.728 -529)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_13171",
    "data-name": "Rectangle 13171",
    width: 135,
    height: 112,
    rx: 10,
    transform: "translate(376.728 529)",
    fill: "#00aec7"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_28021",
    "data-name": "Group 28021",
    transform: "translate(243.538 16.402)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_13155",
    "data-name": "Rectangle 13155",
    transform: "translate(165.19 541.598)",
    fill: "#00aec7",
    stroke: "#fff",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("rect", {
    width: 57,
    height: 33,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 55,
    height: 31,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_13156",
    "data-name": "Rectangle 13156",
    transform: "translate(173.19 551.598)",
    fill: "#00aec7",
    stroke: "#fff",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("rect", {
    width: 58,
    height: 31,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 56,
    height: 29,
    fill: "none"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_13157",
    "data-name": "Rectangle 13157",
    width: 57,
    height: 34,
    transform: "translate(183.19 562.598)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_93",
    "data-name": "Ellipse 93",
    cx: 5.5,
    cy: 5.5,
    r: 5.5,
    transform: "translate(442 584)",
    fill: "#00aec7"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_13149",
    "data-name": "Rectangle 13149",
    width: 11,
    height: 11,
    transform: "translate(459 584)",
    fill: "#00aec7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33802",
    "data-name": "Path 33802",
    d: "M5.358,0l5.358,10.717H0Z",
    transform: "translate(442 598.066)",
    fill: "#00aec7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_33801",
    "data-name": "Path 33801",
    d: "M0,0V10.717H10.717Z",
    transform: "translate(459 598.066)",
    fill: "#00aec7"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDesignCanvasHove);
export default __webpack_public_path__ + "static/media/design_canvas_hove.50d03697679d036e3707b97f8abb8060.svg";
export { ForwardRef as ReactComponent };